// extracted by mini-css-extract-plugin
export var description = "ServiceRoll-module--description--zxffm";
export var document = "ServiceRoll-module--document--ttNaF";
export var image = "ServiceRoll-module--image--PxflA";
export var line = "ServiceRoll-module--line--ZBxgG";
export var service = "ServiceRoll-module--service--8gikY";
export var serviceObject = "ServiceRoll-module--service-object--Plgz4";
export var text = "ServiceRoll-module--text--8ASxA";
export var title = "ServiceRoll-module--title--2BT-u";